
import { defineComponent, ref, onActivated, computed, getCurrentInstance, onMounted, SetupContext } from 'vue';
import Toast from 'vant/lib/toast';
import Skeleton from 'vant/lib/skeleton';
import MutedIcon from '../muted/index.vue';
import FoldableItem from '../foldable-item-new/index.vue';
import CommentDialog from '@/components/comment-dialog/seo-index.vue';
import { roundingNum, addHashtagLinks } from '@/common/utils';
import { getLlsidFromExptag } from '@/common/common-params';
import { useCommentDialog } from '@/components/comment-dialog/hooks/useCommentDialog';
import { sendLog, radarLog } from '~/common/radar';
import Loading from '@/components/loading/index.vue';
import { MobilePageSource } from '@/constants/base';

export default defineComponent({
    components: {
        MutedIcon,
        FoldableItem,
        CommentDialog,
        Loading,
        Skeleton,
    },
    props: {
        type: {
            type: String,
            default: () => '',
        },
        data: {
            type: Object,
            default: () => {},
        },
        muted: {
            type: Boolean,
            default: true,
        },
        isLoginStatus: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            default: 0,
        },
        firstCardFinishLoad: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, ctx: SetupContext<Array<'onFirstFinishRender'>>) {
        const { proxy } = getCurrentInstance() as { proxy: any };
        let videoElement: any;

        const isActived = ref(false);
        const isPlaying = ref(false);
        const showIcon = ref(false);
        const isIOS = ref(false);
        const loading = ref(false);
        const startPlayTime = ref(0);
        const videoComp = ref();
        const cardType = ref('video-category-card');

        const getVideoEle = () => {
            console.log('category getVideoEle-->', props.index, videoComp.value);
            return videoComp.value;
        };

        const cardCommonParams = computed(() => {
            return {
                card_type: 'photo_card',
                is_ad: showPlc.value,
                card_position: props.index,
            };
        });

        const clickPlayOrPause = () => {
            if (isPlaying.value) {
                sendLog({
                    type: 'click',
                    name: 'PHOTO_CARD_SPECIAL',
                    value: {
                        button_type: 'pause',
                        ...cardCommonParams.value,
                    },
                });
                setVideoPause();
                isPlaying.value = false;
            } else {
                sendLog({
                    type: 'click',
                    name: 'PHOTO_CARD_SPECIAL',
                    value: {
                        button_type: 'play',
                        ...cardCommonParams.value,
                    },
                });
                setVideoPlay();
                isPlaying.value = true;
            }
        };
        const setVideoPlay = () => {
            if (!videoElement) {
                videoElement = getVideoEle();
            }
            console.log('category setVideoPlay-->', props.index, videoElement);
            videoElement?.play();
        };
        const setVideoPause = () => {
            if (!videoElement) {
                videoElement = getVideoEle();
            }
            console.log('category setVideoPause-->', props.index, videoElement);
            videoElement?.pause();
            setAllVideoPause();
        };
        const setAllVideoPause = () => {
            proxy.$emit('setAllVideoPause', props.index);
        };
        const { commentLists, commentDialogVisable, showCommentLoading, fetchSeoComment } = useCommentDialog();

        const cardSize = computed(() => {
            const startUpData = proxy.$store.state.startup;
            const abParam = startUpData?.search_web_play_length_switch;
            let size = 'small';
            if (['middle', 'large', 'full'].includes(abParam)) {
                size = abParam;
            }
            return `card-${size}`;
        });

        const kwaiId = computed(() => {
            return props.data?.feeds?.kwai_id;
        });
        const likeCount = computed(() => {
            return props.data?.feeds?.like_count > 10 ? props.data?.feeds?.like_count : proxy.$root.$t('k_344306');
        });
        const commentCount = computed(() => {
            return props.data?.feeds?.comment_count > 10 ? props.data?.feeds?.comment_count : proxy.$root.$t('k_467898');
        });
        const shareCount = computed(() => {
            return props.data?.feeds?.forward_count > 10 ? props.data?.feeds?.forward_count : proxy.$root.$t('k_467899');
        });
        const userName = computed(() => {
            return props.data?.feeds?.user_name || '';
        });
        const userHeadIcon = computed(() => {
            return props.data?.feeds?.headurls?.[0]?.url || '';
        });
        const playCount = computed(() => {
            return props.data?.feeds?.view_count || 0;
        });

        const caption = computed(() => {
            return props.data?.feeds?.caption;
        });

        const hiddenCommentLikeCount = computed(() => {
            return props.data?.comment?.commentLikeCount > 5;
        });

        const commentLikeCount = computed(() => {
            return roundingNum(props.data?.comment?.commentLikeCount);
        });

        const commentUserName = computed(() => {
            return props.data?.comment?.userName;
        });
        const commentUserHead = computed(() => {
            return props.data?.comment?.userHeads?.[0].url;
        });
        const content = computed(() => {
            return props.data?.comment?.content;
        });

        const showPlc = computed(() => {
            return props.data?.feeds?.feedType === 'AD';
        });

        const plcIcon = computed(() => {
            return props.data?.feeds?.plcIcon;
        });

        const plcDesc = computed(() => {
            return props.data?.feeds?.plcText;
        });

        const plcLink = computed(() => {
            return props.data?.feeds?.feedLink;
        });

        const hashTagText = computed(() => {
            return addHashtagLinks(props.data?.comment?.content);
        });

        const timeFormate = computed(() => {
            return timeStampToDisplayString(props.data?.feeds?.timestamp, proxy);
        });

        const mainUrl = computed(() => {
            return props.data?.feeds?.transcode_manifest_info || props.data?.feeds?.main_mv_urls?.[0]?.url || 0;
        });

        const postImg = computed(() => {
            return props.data?.feeds?.cover_thumbnail_urls?.[0]?.url || '';
        });

        const photoId = computed(() => {
            return props.data?.feeds?.photo_id_str;
        });

        const handleLikeAction = () => {
            sendLog({
                type: 'click',
                name: 'PHOTO_CARD_SPECIAL',
                value: {
                    button_type: 'like',
                    ...cardCommonParams.value,
                },
            });
            if (!props.isLoginStatus) {
                proxy.$bus.emit('changeLoginPopupShow', true);
            } else {
                clicklikeAction(photoId.value);
            }
        };
        // 点赞
        const clicklikeAction = async (photoId: number) => {
            if (isActived.value) return;
            const { result, errorMsg } = await proxy.$axios.$$post('overseaAPI::/rest/o/w/pwa/likeAction', {
                fromPage: 'new_discover',
                cancel: false,
                photoId,
            });
            if (result === 1) {
                isActived.value = true;
                // 未登录
            } else if (result === 109 || result === 1047232003) {
                proxy.$bus.emit('changeLoginPopupShow', true);
            } else {
                errorMsg &&
                    Toast({
                        message: errorMsg,
                    });
            }
        };

        const handleAdClick = () => {
            if (showPlc.value && plcLink.value) {
                sendLog({
                    type: 'click',
                    name: 'PHOTO_CARD_SPECIAL',
                    value: {
                        ...cardCommonParams.value,
                    },
                });
                setVideoPause();
                window.open(plcLink.value, '_blank');
            }
        };

        const handleCommentClick = () => {
            sendLog({
                type: 'click',
                name: 'PHOTO_CARD_SPECIAL',
                value: {
                    button_type: 'comment',
                    ...cardCommonParams.value,
                },
            });
            commentDialogVisable.value = true;
            fetchSeoComment(photoId.value);
        };
        const handleCommentJumpClick = () => {
            sendLog({
                type: 'click',
                name: 'PHOTO_CARD_SPECIAL',
                value: {
                    button_type: 'comment_icon',
                    ...cardCommonParams.value,
                },
            });
            proxy.$router.push({ path: `/@${kwaiId.value}`, query: { page_source: 'new_discover' } });
        };
        const clickHeaderOrName = () => {
            // ikwai://search?tab=video?source=PWA&keyword=${encodeURIComponent(searchContent.value)}&target_url=${getTargetUrlFromWebOrDesktop()}
            // evokeByTagA(`ikwai://profile/${photoId.value}`)
            sendLog({
                type: 'click',
                name: 'PHOTO_CARD_SPECIAL',
                value: {
                    button_type: 'author_icon',
                    ...cardCommonParams.value,
                },
            });
            proxy.$router.push({ path: `/@${kwaiId.value}`, query: { page_source: 'new_discover' } });
        };

        // 格式化时间 gpt
        function timeStampToDisplayString(timestamp: number, proxy: any) {
            // 获取当前时间戳以及一天的时间戳
            const now = Date.now();
            const oneDay = 24 * 60 * 60 * 1000;

            // 计算时间戳和当前时间之间的差距
            const timeDiff = now - timestamp;

            // 判断是否在24小时内 k_430982
            if (timeDiff < oneDay) {
                return proxy.$root.$t('k_430982');
            }

            // 判断是否在七天内
            if (timeDiff < 7 * oneDay) {
                // 计算相差的天数
                const diffDays = Math.floor(timeDiff / oneDay);
                return proxy.$root.$t('k_430983').replace('${0}', diffDays);
            }
            // 7天外
            return proxy.$root.$t('k_430983').replace('${0}', 7);
        }

        const copyUrl = () => {
            sendLog({
                type: 'click',
                name: 'PHOTO_CARD_SPECIAL',
                value: {
                    button_type: 'share',
                    ...cardCommonParams.value,
                },
            });
            proxy.$bus.emit('copyToClipboard', `${window.location.href}?copyType=category`);
        };

        const handleVideoClick = () => {
            sendLog({
                type: 'click',
                name: 'PHOTO_COVER',
                value: {
                    ...logParams.value,
                },
            });
            proxy?.$router?.push({ path: `/@${kwaiId.value}/video/${photoId.value}`, query: { page_source: 'new_discover' } });
        };
        const handlePlaying = () => {
            isPlaying.value = true;
            showIcon.value = true;
            loading.value = false;
        };

        const handleCanPlay = (index: number) => {
            // eslint-disable-next-line vue/require-explicit-emits
            ctx.emit('onFirstFinishRender', index);
        };

        const handleOnPlay = () => {
            loading.value = true;
            startPlayTime.value = new Date().getTime();
        };
        const handlePlayEnd = () => {
            isPlaying.value = false;
        };
        const sendPlayTimeLog = (ifError: number) => {
            const videoComp = getVideoEle();
            const playTime = videoComp?.getCurrentTime() || 0;
            const duration = videoComp?.getDuration() || 0;
            console.log('handlePause-->', props.index, playTime, duration);
            console.log('handlePause-->, props', props);
            if (playTime > 0 && photoId.value && duration > 0) {
                sendLog({
                    type: 'click',
                    name: 'PLAY_TIME_MOBILE',
                    value: {
                        photo_id: photoId.value,
                        author_id: props?.data?.feeds?.user_id,
                        play_time: playTime,
                        photo_time: duration,
                        if_error: ifError,
                        exp_tag: props?.data?.feeds?.exp_tag,
                        llsid: getLlsidFromExptag(props?.data?.feeds?.exp_tag),
                    },
                });
            }
        };

        const handlePause = () => {
            showIcon.value = false;
            isPlaying.value = false;
            sendPlayTimeLog(0);
            startPlayTime.value = new Date().getTime();
        };
        const handleError = (e: any) => {
            radarLog({
                name: 'PWA_VIDEO_ERROR_IN_DISCOVER',
                event_type: 'click',
                category: 'KWAI_SHARE',
                message: `error url: ${mainUrl.value}`,
                src: window.location.pathname,
            });
            sendPlayTimeLog(1);
        };
        const handleWaiting = (e: any) => {};
        const logParams = computed(() => {
            return {
                author_id: props?.data?.feeds?.user_id,
                photo_id: photoId.value,
                like: likeCount.value,
                play: playCount.value,
                comment: commentCount.value,
                share: shareCount.value,
                card_type: 'photo_card',
            };
        });

        // const handleVisibilityChange = () => {
        //   if (document.hidden) {
        //     // console.log("页面被隐藏了");
        //     setVideoPause()
        //   } else {
        //     setVideoPlay()
        //   }
        // };

        onMounted(() => {
            videoElement = getVideoEle();
        });

        onActivated(() => {
            commentDialogVisable.value = false;
        });

        return {
            likeCount,
            commentCount,
            shareCount,
            playCount,
            hiddenCommentLikeCount,
            commentLikeCount,
            commentUserName,
            commentUserHead,
            timeFormate,
            isActived,
            postImg,
            content,
            photoId,
            commentLists,
            commentDialogVisable,
            showCommentLoading,
            isPlaying,
            userName,
            userHeadIcon,
            caption,
            mainUrl,
            logParams,
            hashTagText,
            showIcon,
            isIOS,
            loading,
            handlePause,
            handlePlayEnd,
            handleCommentJumpClick,
            fetchSeoComment,
            handleVideoClick,
            roundingNum,
            handleCommentClick,
            copyUrl,
            handleLikeAction,
            clickHeaderOrName,
            clickPlayOrPause,
            handlePlaying,
            handleError,
            handleWaiting,
            handleOnPlay,
            handleCanPlay,
            getVideoEle,
            cardType,
            videoComp,
            cardSize,
            showPlc,
            plcIcon,
            plcDesc,
            plcLink,
            handleAdClick,
            cardCommonParams,
            bizData: { pageSource: MobilePageSource.PwaDiscoverCategoryCard },
        };
    },
});
